import React, {useEffect, useState} from 'react';
import {AbsenceCodesContext} from "root/s360components/Contexts/AbsenceCodes/AbsenceCodesContext";
import {getDatabaseAbsenceCodes} from "root/DataFunctions/RegistrationDataFns";
import {getAbsenceCodes} from "root/s360components/ReactHookForm/ui/DropdownAbsenceCode";

const AbsenceCodesProvider = (props) => {

    const [ data, setData ] = useState ( {isLoading: true, data: [] }) ;

    useEffect(() => {
        getDatabaseAbsenceCodes((response) =>
        {
            const formattedData = getAbsenceCodes(response.results.record_set, false);

            setData({isLoading: false, data: formattedData});
        }) ;
    }, []);

    return (
        <AbsenceCodesContext.Provider
            value={{
                absenceCodes: data.data,
                loadingAbsenceCodes: data.isLoading,
            }}
        >
            {props.children}
        </AbsenceCodesContext.Provider>
    )
}

export default AbsenceCodesProvider;